import React from "react";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import type { StackScreenProps } from "@react-navigation/stack";
import { FertilityTestingTypesScreen } from "./FertilityTestingTypesScreen/FertilityTestingTypesScreen";
import { UrineTestsScreen } from "./UrineTestsScreen/UrineTestsScreen";
import { ImagingTestsScreen } from "./ImagingTestsScreen/ImagingTestsScreen";
import { SamplingTestsScreen } from "./SamplingTestsScreen/SamplingTestsScreen";
import { GeneticTestsScreen } from "./GeneticTestsScreen/GeneticTestsScreen";
import { BloodTestsScreen } from "./BloodTestsScreen/BloodTestsScreen";
import { FertilityTestingCompleteScreen } from "./FertilityTestingCompleteScreen/FertilityTestingCompleteScreen";
import { FertilityTestingProvider } from "./FertilityTestingContext";
import { MedicalHistoryQuestionProvider } from "@src/packages/medical-history/components";

export type FertilityTestingStackParamList = {
  FertilityTestingTypes: undefined;
  UrineTests: undefined;
  ImagingTests: undefined;
  SamplingTests: undefined;
  GeneticTests: undefined;
  BloodTests: undefined;
  FertilityTestingComplete: undefined;
};

export type FertilityTestingStackScreenProps<
  T extends keyof FertilityTestingStackParamList,
> = StackScreenProps<FertilityTestingStackParamList, T>;

const Stack = createNativeStackNavigator<FertilityTestingStackParamList>();

export function FertilityTestingNavigator() {
  return (
    <FertilityTestingProvider>
      <MedicalHistoryQuestionProvider
        section="fertility-testing"
        sectionLabelKey="med_history.review.section_title.fertility-testing"
        helpTextKey="med_history.question_screen.flow_help.fertility-testing"
      >
        <Stack.Navigator
          screenOptions={{
            headerShown: false,
            contentStyle: { backgroundColor: "transparent" },
          }}
        >
          <Stack.Screen
            name="FertilityTestingTypes"
            component={FertilityTestingTypesScreen}
          />
          <Stack.Screen name="UrineTests" component={UrineTestsScreen} />
          <Stack.Screen name="ImagingTests" component={ImagingTestsScreen} />
          <Stack.Screen name="SamplingTests" component={SamplingTestsScreen} />
          <Stack.Screen name="GeneticTests" component={GeneticTestsScreen} />
          <Stack.Screen name="BloodTests" component={BloodTestsScreen} />
          <Stack.Screen
            name="FertilityTestingComplete"
            component={FertilityTestingCompleteScreen}
          />
        </Stack.Navigator>
      </MedicalHistoryQuestionProvider>
    </FertilityTestingProvider>
  );
}
